<script>
export default {
  name: 'ReturnGoodsList'
}

</script>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import DeleteFromReturnBoxConfirmModal from "./modal/DeleteFromReturnBoxConfirmModal.vue";
import ReturnGoods from './ReturnGoods.vue';
import { url } from '@/config/urls';

// emit定義
const emit = defineEmits([
  'updateReturnBoxQuantity',
  'updateLoading',
  'setOperatingGoodsData',
  'checkDuplicateInReturnBox',
  'addToReturnBox',
  'countReturnBox',
  'apiError',
  'validationError',
  'returnBoxDeleted'
]);

// ローディングフラグ更新
const handleUpdateLoading = (isLoading) => {
  emit('updateLoading', isLoading);
}

// エラー処理
const handleApiError = (error) => {
  emit('apiError', error);
}

const validationErrorHandle = (key, value) => {
  emit('validationError', key, value)
}

// prop定義
const props = defineProps({
  /**
   * 画面ID
   *    [返品依頼TOP] ReturnSearch
   *    [返品履歴] ReturnHistory
   *    [返品ボックス] ReturnBox
   */
  screenId: {
      type: String,
      required: true
  },
  // 商品情報
  goodsList: {
    type: Array,
    required: true
  },
  // 商品分類マスタデータ
  goodsTypes: {
    type: Array,
    required: true
  },
  // 返品ボックス削除API URL
  returnBoxDeleteApiUrl: {
    type: String,
    default: url.api.returnBox.delete
  },
  // 返品ボックス画面URL
  returnBoxPageUrl: {
    type: String,
    default: url.page.returnBox
  }
});

// モーダル用商品データ（グローバル状態として管理）
const operatingGoodsData = ref(null);
// モーダル用商品データ更新
const setOperatingGoodsData = (goods) => {
  operatingGoodsData.value = goods;
  emit('setOperatingGoodsData', operatingGoodsData.value);
}

// 返品ボックス 削除
const deleteFromReturnBox = () => {
  const salesDetailsLotId = operatingGoodsData.value.salesDetailsLotId;
  emit('updateLoading', true);
  axios.post(props.returnBoxDeleteApiUrl, {salesDetailsLotIdList: [salesDetailsLotId]})
    .then((response) => {
      emit('returnBoxDeleted');
    })
    .catch((error) => {
      emit('apiError', error);
    })
    .finally(() => {
      // 操作中商品データをクリア
      operatingGoodsData.value = null;
      emit('updateLoading', false);
    });
}

</script>

<template>

  <ReturnGoods
    v-for="(goods, index) in goodsList"
    :key="props.screenId === 'ReturnHistory' ? index : goods.salesDetailsLotId"
    :screenId = props.screenId
    :goods = goods
    :goodsTypes = props.goodsTypes
    :index = index
    @setOperatingGoodsData="setOperatingGoodsData"
    @updateLoading="handleUpdateLoading"
    @checkDuplicateInReturnBox="emit('checkDuplicateInReturnBox')"
    @addToReturnBox="emit('addToReturnBox')"
    @deleteFromReturnBox="deleteFromReturnBox"
    @countReturnBox="emit('countReturnBox')"
    @apiError="handleApiError"
    @validationError="validationErrorHandle"
  ></ReturnGoods>
    
  <!-- 返品ボックス 削除確認モーダル -->
  <DeleteFromReturnBoxConfirmModal
    :operatingGoodsData=operatingGoodsData
      @deleteFromReturnBox="deleteFromReturnBox"
  ></DeleteFromReturnBoxConfirmModal>

</template>

